'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createSvgIcon = {};

exports.__exports = createSvgIcon;
